import { Component, Input, ChangeDetectionStrategy, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'eui-file-upload-progress',
    templateUrl: './eui-file-upload-progress.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class EuiFileUploadProgressComponent {
    @Input() progress = 0;
}
